import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

import OneTimeChoice from './OneTimeChoice'
import MembershipChoices from './MembershipChoices'
import RevenueCatPricing from './RevenueCatPricing'
import PricingHero from './PricingHero'
import {
  configureRevenueCatWeb,
  setPurchaseLinks,
  setPurchasePackageIds,
  purchaseByProductId,
} from '../../utils/revenuecatWeb'

class Pricing extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTab: 1,
      current_membership: '',
      free_membership: false,
      current_user: {},
      revenueCatReady: false,
      revenueCatEnabled: false,
      revenueCatError: null,
    }

    this.onClick = this.onClick.bind(this)
    this.setUser = this.setUser.bind(this)
    this.openMembershipCheckout = this.openMembershipCheckout.bind(this)
    this.openOneTimeCheckout = this.openOneTimeCheckout.bind(this)
    this.getSubscription = this.getSubscription.bind(this)
    this.purchaseRevenueCatProduct = this.purchaseRevenueCatProduct.bind(this)
    this.handlePageShow = this.handlePageShow.bind(this)
  }

  handlePageShow() {
    this.getSubscription()
  }

  setUser() {
    if (this.state.current_user === null) {
      return
    }
    if (this.state.current_user != null && this.state.subscription != null && this.state.subscription.plan_id != null) {
      if ([1, 3, 5].includes(this.state.subscription.plan_id)) {
        this.setState({ current_membership: 'Pro', free_membership: false })
      } else if ([2, 4, 6].includes(this.state.subscription.plan_id)) {
        this.setState({ current_membership: 'Elite', free_membership: false })
      }
    } else if (this.state.current_user.premium || this.state.current_user.basic_forever) {
      this.setState({ current_membership: 'Pro', free_membership: true })
    }
  }

  getSubscription() {
    $.ajax({
      url: `${window.location.origin}/get_subscription`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json',
      },
      success: (data) => {
        this.setState({
          current_user: JSON.parse(data.data.current_user),
          subscription: JSON.parse(data.data.subscription),
          id_verification: JSON.parse(data.data.id_verification),
        }, () => this.setUser())
      },
      error(xhr, status, err) {
        console.log(err)
      },
    })
  }

  async componentDidMount() {
    await this.getSubscription()
    this.setState({
      selectedTab: this.props.oneTime === 'true' ? 2 : 1,
    })

    await this.loadRevenueCatConfig()
    window.addEventListener('pageshow', this.handlePageShow)
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageShow)
  }

  loadRevenueCatConfig() {
    return fetch('/revenuecat_config', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((res) => res.json())
      .then((json) => {
        const cfg = json.data
        if (cfg && cfg.legacy_stripe_checkout_disabled && !cfg.web_payments_only) {
          this.setState({
            revenueCatReady: false,
            revenueCatEnabled: false,
            revenueCatError: 'Payments are misconfigured. Contact hello@lexody.com',
          })
          return
        }
        if (!cfg || !cfg.web_api_key) {
          this.setState({
            revenueCatReady: false,
            revenueCatEnabled: false,
            revenueCatError: 'Payments are not configured. Contact hello@lexody.com',
          })
          return
        }

        const links = cfg.purchase_links || {}
        const hasAnyLink = Object.keys(links).some((key) => links[key])
        if (!hasAnyLink) {
          this.setState({
            revenueCatReady: false,
            revenueCatEnabled: false,
            revenueCatError: 'Purchase links are not configured on the server.',
          })
          return
        }

        configureRevenueCatWeb(cfg.web_api_key, cfg.app_user_id)
        setPurchaseLinks(links)
        setPurchasePackageIds(cfg.purchase_package_ids || {})
        this.setState({
          revenueCatReady: true,
          revenueCatEnabled: true,
          revenueCatError: null,
        })
      })
      .catch(() => {
        this.setState({
          revenueCatReady: false,
          revenueCatEnabled: false,
          revenueCatError: 'Could not load payment configuration.',
        })
      })
  }

  onClick(selectedTab) {
    this.setState({ selectedTab })
  }

  ensureRevenueCatReady() {
    if (this.state.revenueCatReady) {
      return true
    }
    alert(this.state.revenueCatError || 'Payment options are still loading. Please wait a moment and try again.')
    return false
  }

  openMembershipCheckout(plan_id) {
    if (this.state.current_user === null) {
      window.location.assign('/sign_in')
      return
    }
    if (!this.ensureRevenueCatReady()) {
      return
    }
    const productId =
      plan_id === 6
        ? 'com.lexody.lexodyapp.yearly_premium_access'
        : 'com.lexody.lexodyapp.monthly_premium_access'
    this.purchaseRevenueCatProduct(productId)
  }

  openOneTimeCheckout(item_id) {
    if (this.state.current_user === null) {
      window.location.assign('/sign_in')
      return
    }
    if (!this.ensureRevenueCatReady()) {
      return
    }
    const productId =
      item_id === 3
        ? 'com.lexody.lexodyapp.10_connect_coins'
        : 'com.lexody.lexodyapp.1_connect_coin'
    this.purchaseRevenueCatProduct(productId)
  }

  async purchaseRevenueCatProduct(productId) {
    try {
      await purchaseByProductId(productId)
    } catch (err) {
      console.error('[RevenueCat] purchase failed', err)
      alert((err && err.message) || 'Purchase failed. Please try again.')
    }
  }

  renderPaymentLoading() {
    if (this.state.revenueCatReady || this.state.revenueCatError) {
      return null
    }
    return (
      <p className="pricing-alert pricing-alert--loading">
        Loading payment options…
      </p>
    )
  }

  renderPaymentError() {
    if (!this.state.revenueCatError) {
      return null
    }
    return (
      <p className="pricing-alert pricing-alert--error">
        {this.state.revenueCatError}
      </p>
    )
  }

  images() {
    return this.props.images || {}
  }

  render() {
    const isMembership = this.state.selectedTab === 1
    const contentClass = `pricing-page__content${!this.state.revenueCatReady && !this.state.revenueCatError ? ' pricing-page__content--loading' : ''}`

    return (
      <div className="pricing-page">
        <PricingHero tab={this.state.selectedTab} images={this.images()} />

        <div className="pricing-page__body">
          <div className="pricing-tabs" role="tablist">
            <button
              type="button"
              role="tab"
              aria-selected={isMembership}
              className={`pricing-tabs__tab${isMembership ? ' pricing-tabs__tab--active' : ''}`}
              onClick={() => this.onClick(1)}
            >
              Membership
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={!isMembership}
              className={`pricing-tabs__tab${!isMembership ? ' pricing-tabs__tab--active' : ''}`}
              onClick={() => this.onClick(2)}
            >
              Lexicoins
            </button>
          </div>

          <div className={contentClass}>
          {this.renderPaymentLoading()}
          {this.renderPaymentError()}

          {isMembership && (
            <MembershipChoices
              subscription={this.state.subscription}
              current_user={this.state.current_user}
              currentMembership={this.state.current_membership}
              freeMembership={this.state.free_membership}
              openCheckout={this.openMembershipCheckout}
              images={this.images()}
            />
          )}

          {!isMembership && (
            <OneTimeChoice
              tab={this.state.selectedTab}
              current_user={this.state.current_user}
              subscription={this.state.subscription}
              id_verification={this.state.id_verification}
              openCheckout={this.openOneTimeCheckout}
              images={this.images()}
            />
          )}

          {this.state.revenueCatEnabled && isMembership && (
            <RevenueCatPricing
              showManageSubscription={this.state.current_membership !== ''}
              configured={this.state.revenueCatReady}
              error={this.state.revenueCatError}
              onPurchaseComplete={() => this.getSubscription()}
            />
          )}
          </div>
        </div>
      </div>
    )
  }
}

Pricing.propTypes = {
  oneTime: PropTypes.string,
  images: PropTypes.object,
}

export default Pricing
